module.exports = __webpack_public_path__ + "static/img/h5.2a35801.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner/pc/h5.jpg
// module id = smI/
// module chunks = 1